import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ActiveModal } from '@frontend/sports/modal/feature';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';

@Component({
    selector: 'bs-quick-bet-technical-error-modal',
    templateUrl: './quick-bet-technical-error-modal.component.html',
    styleUrls: ['./quick-bet-technical-error-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class QuickBetTechnicalErrorModalComponent {
    constructor(
        public sitecore: Sitecore,
        private activeModal: ActiveModal,
        private redirectHelperService: RedirectHelperService,
    ) {}

    close(): void {
        this.activeModal.close();
    }

    goToMyBets(): void {
        this.activeModal.close();
        this.redirectHelperService.goToMyBets();
    }
}
